import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StoreSummary } from '../../../classes/models/store/StoreSummary';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { StoreDetails } from '../../../classes/models/store/StoreDetails';
import { StoreDetailsAdapter } from '../../../classes/adapters/response/store/StoreDetailsAdapter';
import { StoreSummaryAdapter } from '../../../classes/adapters/response/store/StoreSummaryAdapter.service';
import { StoreDetailsResponse, StoreSummaryResponse } from '../../../interfaces/response/StoreResponses';

/**
 * This service communicates with backend to retrieve store data.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreService {
  private http = inject(HttpClient);
  private storeSummaryAdapter = inject(StoreSummaryAdapter);
  private detailsAdapter = inject(StoreDetailsAdapter);

  url = environment.apiUrl + '/stores';

  /**
   * Retries a list of store summaries for all stores, that the current user can access.
   */
  all(): Observable<StoreSummary[]> {
    return this.http.get(this.url).pipe(
      map((data: StoreSummaryResponse[]) => data.map(item => this.storeSummaryAdapter.adapt(item))));
  }

  /**
   * Retrieves full information about a particular store.
   * @param id an identifier of a store.
   */
  getDetails(id: string): Observable<StoreDetails> {
    const url = `${this.url}/${id}`;
    return this.http.get(url).pipe(
      map((item: StoreDetailsResponse) => this.detailsAdapter.adapt(item)));
  }
}
